module.exports = __webpack_public_path__ + "img/product2880.af350cbc.png";